import { gql } from "@stadium/services/apollo-client";
import { ADDRESS_DETAILS } from "@stadium/checkout/src/graphql/fragments/address/details";

export const createAddress = gql`
  mutation CreateAddress($input: CreateUserAddressInput!) @api(name: "users") {
    createAddress(input: $input) {
      success
      errors
      address {
        ...AddressDetails
      }
    }
  }
  ${ADDRESS_DETAILS}
`;
